// ToyotaRouter.jsx
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

// Import namespaced CSS
import '../../pages/toyotaOfficialAccount/toyota-namespace.css';

// Import your Toyota pages
import BindingCar from '../../pages/toyotaOfficialAccount/BindingCar';
import BindingFail from '../../pages/toyotaOfficialAccount/BindingFail';
import BindingSuccess from '../../pages/toyotaOfficialAccount/BindingSuccess';
import BindingWarn from '../../pages/toyotaOfficialAccount/BindingWarn';
import CarServiceBooking from '../../pages/toyotaOfficialAccount/CarServiceBooking';
import CarServiceBookingPaint from '../../pages/toyotaOfficialAccount/CarServiceBookingPaint';
import CarServiceBookingRecord from '../../pages/toyotaOfficialAccount/CarServiceBookingRecord';
import CarServiceBookingRecordDetail from '../../pages/toyotaOfficialAccount/CarServiceBookingRecordDetail';
import CarServiceBookingOrder from '../../pages/toyotaOfficialAccount/CarServiceBookingOrder';
import CarServiceBookingCalendar from '../../pages/toyotaOfficialAccount/CarServiceBookingCalendar';
import Home from '../../pages/toyotaOfficialAccount/Home';
import InsuranceInfo from '../../pages/toyotaOfficialAccount/InsuranceInfo';
import Loading from '../../pages/toyotaOfficialAccount/Loading';
import Error from '../../pages/toyotaOfficialAccount/Error';
import MaintenanceRecord from '../../pages/toyotaOfficialAccount/MaintenanceRecord';
import PrepaidRecord from '../../pages/toyotaOfficialAccount/PrepaidRecord';
import RecallNotice from '../../pages/toyotaOfficialAccount/RecallNotice';
import RedirectPage from '../../pages/toyotaOfficialAccount/Redirect';
import ToyotaPnpPage from '../../pages/toyotaOfficialAccount/pnp/ToyotaPnp';
import PnpWebviewRouter from '../pnpWebview/ToyotaPnpWebviewRouter';

// 自動滾動到頂部的組件
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 使用平滑滾動到頂部，避免跳針感
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  // 組件掛載時也執行滾動
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return null;
}

const ToyotaRouter = () => {
  return (
    <div className="toyota-webview">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/maintenance-record" element={<MaintenanceRecord />} />
        <Route path="/prepaid-record" element={<PrepaidRecord />} />
        <Route path="/insurance-info" element={<InsuranceInfo />} />
        <Route path="/recall" element={<RecallNotice />} />
        <Route path="/binding-car" element={<BindingCar />} />
        <Route path="/binding-fail" element={<BindingFail />} />
        <Route path="/binding-warn" element={<BindingWarn />} />
        <Route path="/binding-success" element={<BindingSuccess />} />
        <Route path="/loading" element={<Loading />} />
        <Route path="/error" element={<Error />} />
        <Route path="/car-service-booking" element={<CarServiceBooking />} />
        <Route
          path="/car-service-booking/paint"
          element={<CarServiceBookingPaint />}
        />
        <Route
          path="/car-service-booking/record"
          element={<CarServiceBookingRecord />}
        />
        <Route
          path="/car-service-booking/record-detail"
          element={<CarServiceBookingRecordDetail />}
        />
        <Route
          path="/car-service-booking-calendar"
          element={<CarServiceBookingCalendar />}
        />
        <Route
          path="/car-service-booking-order"
          element={<CarServiceBookingOrder />}
        />
        <Route path="/redirect" element={<RedirectPage />} />
        <Route path="/pnp" element={<ToyotaPnpPage />} />
        <Route path="/pnp/*" element={<PnpWebviewRouter />}></Route>
      </Routes>
    </div>
  );
};

export default ToyotaRouter;
